<template>
  <div class="app-container">
    <el-form ref="queryForm" :model="queryParams" size="small" :inline="true">
      <el-form-item>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="success" icon="el-icon-edit" :disabled="single" @click="handleUpdate">修改</el-button>
<!--        <el-button type="danger" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">删除</el-button>-->
      </el-form-item>
      <el-form-item label="虚拟用户昵称" prop="name">
        <el-input
          v-model="queryParams.nickname"
          placeholder="虚拟用户昵称"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>

      <el-form-item label="虚拟用户微信" prop="url">
        <el-input
          v-model="queryParams.wechatId"
          placeholder="虚拟用户微信"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-select v-model="queryParams.sex" placeholder="请选择性别">
          <el-option label="女" value="2"></el-option>
          <el-option label="男" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" @click="handleResetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="pageList" border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="序号" type="index" width="100" />
      <el-table-column label="用户昵称" prop="nickname" :show-overflow-tooltip="true" width="100" />
      <el-table-column label="头像" prop="avatar" :show-overflow-tooltip="true" width="250" >
        <template slot-scope="scope">
          <image-preview :src="scope.row.avatar" :width="50" :height="50"/>
        </template>
      </el-table-column>
      <el-table-column label="性别" prop="sex" :formatter="sexFormat" :show-overflow-tooltip="true" width="100" />
      <el-table-column label="微信" prop="wechatId" :show-overflow-tooltip="true" width="250" />
      <el-table-column label="支付方式" prop="payType" :formatter="payTypeFormat" :show-overflow-tooltip="true" width="250" />
      <el-table-column label="创建时间" prop="regTime" :show-overflow-tooltip="true" />
      <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          >修改
          </el-button>
          <el-button
            icon="el-icon-view"
            type="text"
            size="small"
            plain
            class="none-border"
            @click.stop="handleUserInfo(scope.row)"
          >查看
          </el-button>
<!--          <el-button
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
          >删除
          </el-button>-->
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="pagination.total>0"
      :total="pagination.total"
      :page.sync="pagination.page"
      :limit.sync="pagination.limit"
      @pagination="handleQuery"
    />

    <!-- 添加虚拟用户配置对话框 -->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="添加数量" prop="num">
          <el-input-number v-model="form.num"  :min="1" :max="100" label="请输入添加数量" />
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="form.sex" placeholder="请选择性别">
            <el-option label="女" value="2"></el-option>
            <el-option label="男" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
        <el-button @click="dialog.visible=false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 修改虚拟用户配置对话框 -->
    <el-dialog :title="dialogUpdate.title" :visible.sync="dialogUpdate.visible" width="600px">
      <el-form ref="updateForm" :model="updateForm" :rules="rules" label-width="100px">
        <el-form-item label="昵称">
          <el-input v-model="updateForm.nickname"  label="请输入昵称" />
        </el-form-item>
        <el-form-item label="微信">
          <el-input v-model="updateForm.wechatId"  label="请输入微信" />
        </el-form-item>
        <el-form-item label="头像">
          <single-upload-cos v-model="updateForm.avatar" />
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select  v-model="updateForm.payType">
            <el-option label="AA" :value="1"></el-option>
            <el-option label="你请" :value="3"></el-option>
            <el-option label="我请" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="生日">
          <el-date-picker
            v-model="updateForm.birthyear"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="生日"
            clearable
            style="width: 240px"
          />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleUpdateSubmit">确 定</el-button>
        <el-button @click="dialogUpdate.visible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { list, detail, update, add, del,createVirtualUser,syncVirtualUser } from '@/api/member/simulate'
import SingleUploadCos from "@/components/upload/single-upload-cos";
import dayjs from 'dayjs'

export default {
  components: {
    SingleUploadCos
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      queryParams: {
        name: undefined
      },
      pagination: {
        page: 1,
        limit: 10,
        total: 0
      },
      pageList: [],
      dialog: {
        title: undefined,
        visible: false
      },
      dialogUpdate:{
        title: undefined,
        visible: false
      },
      dialogPhoto:{
        title: undefined,
        visible: false
      },
      updateForm:{},
      photoForm:{},
      // 菜单列表
      menuOptions: [],
      // 表单参数
      form: {
        num: 1,
        sex: 2
      },
      // 表单校验
      rules: {
        num: [
          { required: true, message: '数量不能为空', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '性别不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.handleQuery()
  },
  methods: {
    handleUserInfo({id}) {
      this.$router.push({ path: '/member/detail', query: { userId: id }})
    },
    sexFormat(row) {
      return row.sex === 1 ? '男' : '女'
    },
    payTypeFormat(row) {
      if (row.payType == 1){
        return "AA"
      }
      if (row.payType == 2){
        return "我请"
      }
      if (row.payType == 3){
        return "找人请"
      }
    },
    handleQuery() {
      this.queryParams.page = this.pagination.page
      this.queryParams.limit = this.pagination.limit
      list(this.queryParams).then(response => {
        this.pageList = response.data
        this.pagination.total = response.total
        this.loading = false
      })
    },
    handleResetQuery() {
      this.pagination = {
        page: 1,
        limit: 10,
        total: 0
      }
      this.queryParams = {
        name: undefined
      }
      this.handleQuery()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length != 1
      this.multiple = !selection.length
    },
    handleStatusChange(row) {
      const text = row.status === 1 ? '启用' : '停用'
      this.$confirm('确认要"' + text + row.name + '"数据项吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function() {
        return patch(row.id, { status: row.status })
      }).then(() => {
        this.$message.success(text + '成功')
      }).catch(function() {
        row.status = row.status === 1 ? 0 : 1
      })
    },
    handleAdd() {
      this.resetForm()
      this.dialog = {
        title: '新增虚拟用户',
        visible: true
      }
    },
    handleUpdate(row) {
      this.resetUpdateForm()
      this.dialogUpdate = {
        title: '修改虚拟用户',
        visible: true
      }
      const id = row.id || this.ids
      detail(id).then(response => {
        this.updateForm = response.data
      })
    },
    handleDelete(row) {
      const ids = [row.id || this.ids].join(',')
      console.log(this.ids)
      this.$confirm('是否确认删除选中的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        del(ids).then(() => {
          this.$message.success('删除成功')
          this.handleQuery()
        })
      }).catch(() =>
        this.$message.info('已取消删除')
      )
    },
    handleSubmit: function() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const id = this.form.id
          if (id != undefined) {
            update(this.form.id, this.form).then(() => {
              this.$message.success('修改成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          } else {
            createVirtualUser(this.form.num,this.form.sex).then(() => {
              this.$message.success('新增成功')
              this.dialog.visible = false
              this.handleQuery()
            })
          }
        }
      })
    },
    handleUpdateSubmit(){
      this.$refs['updateForm'].validate(valid => {
        if (valid) {
          const id = this.updateForm.id
          if (id != undefined) {
            update(this.updateForm.id, this.updateForm).then(() => {
              this.$message.success('修改成功')
              this.dialogUpdate.visible = false
              this.handleQuery()
            })
          }
        }
      })
    },
    resetForm() {
      this.form = {
        id: undefined,
        name: undefined,
        url: undefined
      }
      if (this.$refs['form']) {
        this.$refs['form'].resetFields()
      }
    },
    resetUpdateForm() {
      this.updateForm = {
        id: undefined,
        avatar: undefined,
        wechatId: undefined,
        nickname: undefined
      }
      if (this.$refs['updateForm']) {
        this.$refs['updateForm'].resetFields()
      }
    },
  }
}
</script>
